// frontend_MainDashboard/src/hooks/api/useCampaignApi.ts

import { useCallback } from 'react';
import { useApiBase } from './useApiBase';

// Note: These types are imported from '../types' in useActualApi.ts
// They should ideally be moved to shared package, but keeping import pattern for now
export interface CampaignApiHook {
  createBulkCampaign: (payload: import('../../types').CreateBulkCampaignPayload) => Promise<import('../../types').BulkCampaignResponse>;
  fetchBulkCampaigns: (limit?: number) => Promise<import('../../types').BulkCampaignsListResponse>;
  getBulkCampaignDetails: (campaignId: string) => Promise<import('../../types').BulkCampaignResponse>;
  updateBulkCampaign: (campaignId: string, payload: import('../../types').UpdateBulkCampaignPayload) => Promise<{ success: boolean; message?: string }>;
  getCampaignProgress: (campaignId: string) => Promise<{ success: boolean; progress?: any; message?: string }>;
}

export const useCampaignApi = (): CampaignApiHook => {
  const { makeRequest } = useApiBase();

  const createBulkCampaign = useCallback(async (payload: import('../../types').CreateBulkCampaignPayload): Promise<import('../../types').BulkCampaignResponse> => {
    return makeRequest<import('../../types').BulkCampaignResponse, import('../../types').CreateBulkCampaignPayload>('/client/bulk_campaigns', 'POST', payload);
  }, [makeRequest]);

  const fetchBulkCampaigns = useCallback(async (limit?: number): Promise<import('../../types').BulkCampaignsListResponse> => {
    const queryParams = limit ? `?limit=${limit}` : '';
    return makeRequest<import('../../types').BulkCampaignsListResponse>(`/client/bulk_campaigns${queryParams}`, 'GET');
  }, [makeRequest]);

  const getBulkCampaignDetails = useCallback(async (campaignId: string): Promise<import('../../types').BulkCampaignResponse> => {
    return makeRequest<import('../../types').BulkCampaignResponse>(`/client/bulk_campaigns/${campaignId}`, 'GET');
  }, [makeRequest]);

  const updateBulkCampaign = useCallback(async (campaignId: string, payload: import('../../types').UpdateBulkCampaignPayload): Promise<{ success: boolean; message?: string }> => {
    return makeRequest<{ success: boolean; message?: string }, import('../../types').UpdateBulkCampaignPayload>(`/client/bulk_campaigns/${campaignId}/update`, 'PUT', payload);
  }, [makeRequest]);

  const getCampaignProgress = useCallback(async (campaignId: string): Promise<{ success: boolean; progress?: any; message?: string }> => {
    return makeRequest<{ success: boolean; progress?: any; message?: string }>(`/client/bulk_campaigns/${campaignId}/progress`, 'GET');
  }, [makeRequest]);

  return {
    createBulkCampaign,
    fetchBulkCampaigns,
    getBulkCampaignDetails,
    updateBulkCampaign,
    getCampaignProgress,
  };
};
